'use strict';

var path = require('path');
var isglob = require('is-glob');

module.exports = function globParent(str) {
	str += 'a'; // preserves full path in case of trailing path separator
	do {str = path.dirname(str)} while (isglob(str));
	return str;
};



//////////////////
// WEBPACK FOOTER
// ./~/glob-base/~/glob-parent/index.js
// module id = 2966
// module chunks = 0